/// <reference types="new-relic-browser" />

import { Injectable } from '@angular/core';

export type NewRelicValueType = newrelic.SimpleType | boolean;

@Injectable({ providedIn: 'root' })
export class NewRelicService {
  addPageAction(
    name: string,
    attributes?: Record<string, NewRelicValueType>
  ): void {
    if (window.newrelic) {
      window.newrelic.addPageAction(name, this.toSimpleTypes(attributes));
    }
  }

  setCustomAttribute(key: string, value: NewRelicValueType): void {
    if (window.newrelic) {
      window.newrelic.setCustomAttribute(key, this.asSimpleType(value));
    }
  }

  setPageViewName(name: string): void {
    if (window.newrelic) {
      window.newrelic.setPageViewName(name);
    }
  }

  noticeError(
    error: Error,
    customAttributes?: Record<string, NewRelicValueType>
  ): void {
    if (window.newrelic) {
      window.newrelic.noticeError(error, this.toSimpleTypes(customAttributes));
    }
  }

  private toSimpleTypes(
    attributes?: Record<string, NewRelicValueType>
  ): Record<string, newrelic.SimpleType> {
    const simpleTypes: Record<string, newrelic.SimpleType> = {};
    if (!attributes) return simpleTypes;
    for (const key in attributes) {
      const value = attributes[key];
      simpleTypes[key] = this.asSimpleType(value);
    }
    return simpleTypes;
  }

  private asSimpleType(value: NewRelicValueType): newrelic.SimpleType {
    if (typeof value === 'boolean') {
      return value ? 'true' : 'false';
    }
    return value;
  }
}
